/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';

import { getFormatValues } from '../../../../lib/utils';

import canvas from '../../../../../img/guest/canvas.svg';

import styles from '../../../../../styles/guest/sections/content/canvas.module.scss';

const propTypes = {
    active: PropTypes.bool,
    className: PropTypes.string,
};

const defaultProps = {
    active: false,
    className: null,
};

const Canvas = ({ active, className }) => (
    <div
        className={classNames([
            styles.container,
            {
                [className]: className !== null,
                [styles.active]: active,
            },
        ])}
    >
        <div className={styles.title}>
            <div className={styles.titleInner} style={{ backgroundImage: `url(${canvas})` }}>
                <h2>
                    <FormattedMessage
                        defaultMessage="An{nbsp}inspiring canvas."
                        description="Guest content - canvas title"
                        values={getFormatValues()}
                    />
                </h2>
            </div>
        </div>
        <div className={styles.description}>
            <div className={styles.descriptionInner}>
                <p>
                    <FormattedMessage
                        defaultMessage="The different types of <strong>micromags</strong> let you integrate and personalize your images, videos or audio files. Give life to your stories with easy-to-use tools that will help you reach your greatest{nbsp}ambitions."
                        description="Guest content - canvas description 1"
                        values={getFormatValues()}
                    />
                </p>
                <p>
                    <FormattedMessage
                        defaultMessage="Experiment with different ideas and preview your most recent updates in real time with a multi-screen view, in all resolutions."
                        description="Guest content - canvas description 2"
                        values={getFormatValues()}
                    />
                </p>
            </div>
        </div>
    </div>
);

Canvas.propTypes = propTypes;
Canvas.defaultProps = defaultProps;

export default Canvas;
